module.exports = __webpack_public_path__ + "static/buyer-profile-19e655d21fead647245a459bf424053b.gif";